/**
 * Offline mutation queue is on by default. Disable with:
 * - `VITE_OFFLINE_QUEUE=0` (Vite apps)
 * - `localStorage.setItem('platzona.offline.queue', '0')`
 */
export function isOfflineQueueEnabled(): boolean {
  try {
    if (typeof localStorage !== 'undefined') {
      const ls = localStorage.getItem('platzona.offline.queue');
      if (ls === '0' || ls === 'false') return false;
      if (ls === '1' || ls === 'true') return true;
    }
  } catch {
    /* ignore */
  }
  try {
    const env = (import.meta as ImportMeta & { env?: Record<string, string> }).env;
    const v = env?.VITE_OFFLINE_QUEUE;
    if (v === '0' || v === 'false') return false;
  } catch {
    /* ignore */
  }
  return true;
}

/**
 * Opt-in last-good cache for central media library *list metadata* (JSON only).
 * Never enables `/file` blob bytes. Enable with:
 * - `VITE_OFFLINE_MEDIA_LIST=1`
 * - `localStorage.setItem('platzona.offline.mediaList', '1')`
 */
export function isMediaListCacheEnabled(): boolean {
  try {
    if (typeof localStorage !== 'undefined') {
      const ls = localStorage.getItem('platzona.offline.mediaList');
      if (ls === '1' || ls === 'true') return true;
      if (ls === '0' || ls === 'false') return false;
    }
  } catch {
    /* ignore */
  }
  try {
    const env = (import.meta as ImportMeta & { env?: Record<string, string> }).env;
    const v = env?.VITE_OFFLINE_MEDIA_LIST;
    if (v === '1' || v === 'true') return true;
    if (v === '0' || v === 'false') return false;
  } catch {
    /* ignore */
  }
  return false;
}
